import { History } from "@insite/mobius/utilities/HistoryContext";

const linkTo = (history: History, url: string | undefined) => {
    if (url) {
        history.push(url);
    }
};

export default linkTo;
